(() => {
  const currentScript = document.currentScript;
  if (!currentScript) return;

  const currentScriptUrl = new URL(currentScript.src);
  const cacheKey = '20260724-13';

  const loadScript = (filename) =>
    new Promise((resolve, reject) => {
      const script = document.createElement('script');
      const scriptUrl = new URL(filename, currentScriptUrl);
      scriptUrl.searchParams.set('gmv', cacheKey);
      script.src = scriptUrl.href;
      script.async = false;
      script.onload = resolve;
      script.onerror = reject;
      document.head.appendChild(script);
    });

  loadScript('cart-drawer-core.js')
    .then(() => loadScript('growmaster-cart-core-safe-v4.js'))
    .then(() => loadScript('growmaster-cart-price-stability.js'))
    .then(() => loadScript('growmaster-rental-cart-layout-v6.js'))
    .then(() => loadScript('growmaster-deposit-screenshot-v7.js'))
    .then(() => loadScript('growmaster-deposit-no-remove-v8.js'))
    .catch((error) => console.error('GrowMaster cart scripts failed to load', error))
    .finally(() =>
      loadScript('growmaster-pdp-sidecart-v8.js')
        .then(() => loadScript('growmaster-cart-variant-gray-v10.js'))
        .catch((error) => console.error('GrowMaster final sidecart fixes failed to load', error))
    );
})();
